module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_4.d19399cb.png";